import { IValuesByEntity } from "../interfaces/common";
import {
  ICarrier,
  IOwnLogisticsCredentialsPayload,
  IPostCarriersChanges,
} from "../interfaces/configuration";
import { IGetCarriers } from "../interfaces/requests";
import {
  ECOMMERCE,
  FORM_DATA_CARRIERS_KEY,
  GET,
  INTERNAL,
  MARKETPLACE,
  MERCHANT,
  OWN_FLEET,
  PATCH,
  POST,
} from "../utils/constants";
import { fetchData } from "../utils/dataProvider";

export const getCarriers = ({
  entity,
  selectedMarketplace = "",
  urlQueryParams = "",
  fetchCredentials = false,
}: IGetCarriers) => {
  const fetchCredentialsParam = fetchCredentials ? "&fetchCredentials=true" : "";
  const carriersEndpointsByEntity: IValuesByEntity = {
    merchant: `carriers_merchants?marketplaceId=${selectedMarketplace}${fetchCredentialsParam}${urlQueryParams}`,
    marketplace: `carriers_clients${urlQueryParams}`,
    ecommerce: `carriers_clients${urlQueryParams}`,
    internal: `internal/carriers${urlQueryParams}`,
  };
  return fetchData({
    url: carriersEndpointsByEntity[entity],
    method: GET,
  });
};

export const postCarriersChanges = ({
  formData, // carriersToUpdate,
  entity,
  selectedMarketplace,
}: IPostCarriersChanges) => {
  const requestByEntity = {
    [MARKETPLACE]: "carriers_clients/integrateCarriers",
    [ECOMMERCE]: "carriers_clients/integrateCarriers",
    [MERCHANT]: `carriers_merchants/carriers/${selectedMarketplace}`,
    [INTERNAL]: "internal/carriers",
  };

  const request = requestByEntity[entity];

  return fetchData({
    url: request,
    method: POST,
    body: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateOwnLogisticsCredentials = (
  body: IOwnLogisticsCredentialsPayload,
  marketplaceId: string
) => {
  const {
    credentials: { matrix, ...credentialsWithoutMatrix },
  } = body;
  // Only send params which are truthy
  const parsedCredentials = Object.fromEntries(
    Object.entries(credentialsWithoutMatrix).filter(([_, value]) =>
      Boolean(value)
    )
  );
  const formData: any = new FormData();
  formData.append(
    FORM_DATA_CARRIERS_KEY,
    JSON.stringify([{ ...body, credentials: parsedCredentials }])
  );
  formData.append(`matrix_${OWN_FLEET}`, matrix);

  return fetchData({
    url: `/carriers_merchants/carriers/${marketplaceId}`,
    method: POST,
    body: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateCarrierStatus = (carrierId: string, enabled: boolean) =>
  fetchData({
    url: `internal/carriers/${carrierId}/status`,
    method: PATCH,
    body: { enabled },
  });

export const updateOwnFleetCarrier = (
  marketplaceId: string,
  body: ICarrier[]
) => {
  const formData = new FormData();
  formData.append(FORM_DATA_CARRIERS_KEY, JSON.stringify(body));

  return fetchData({
    url: `/carriers_merchants/carriers/${marketplaceId}`,
    method: POST,
    body: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
